// Define user roles
export const ROLES = {
  USER: 'USER',
  MANAGER: 'MANAGER',
  MAINTENANCE_MANAGER: 'MAINTENANCE_MANAGER',
  MAINTENANCE_STAFF: 'MAINTENANCE_STAFF',
  FINANCE: 'FINANCE',
  ADMIN: 'ADMIN'
};

// Define ticket statuses
export const TICKET_STATUS = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  MANAGER_REVIEW: 'manager_review',
  MANAGER_APPROVED: 'manager_approved',
  MANAGER_REJECTED: 'manager_rejected',
  MAINTENANCE_REVIEW: 'maintenance_review',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  WAITING_PARTS: 'waiting_parts',
  COMPLETED: 'completed',
  VERIFICATION: 'verification',
  VERIFIED: 'verified',
  FINANCE_REVIEW: 'finance_review',
  CLOSED: 'closed',
  CANCELLED: 'cancelled'
};

// Define permissions for different actions
export const PERMISSIONS = {
  CREATE_TICKET: [ROLES.USER, ROLES.MANAGER, ROLES.ADMIN],
  APPROVE_TICKET: [ROLES.MANAGER, ROLES.MAINTENANCE_MANAGER, ROLES.ADMIN],
  ASSIGN_TICKET: [ROLES.MAINTENANCE_MANAGER, ROLES.ADMIN],
  UPDATE_TICKET: [ROLES.MAINTENANCE_STAFF, ROLES.MAINTENANCE_MANAGER, ROLES.ADMIN],
  VIEW_ALL_TICKETS: [ROLES.MAINTENANCE_MANAGER, ROLES.ADMIN],
  VIEW_DEPARTMENT_TICKETS: [ROLES.MANAGER],
  VIEW_COSTS: [ROLES.FINANCE, ROLES.MAINTENANCE_MANAGER, ROLES.ADMIN],
  VIEW_ANALYTICS: [ROLES.MANAGER, ROLES.MAINTENANCE_MANAGER, ROLES.ADMIN]
};

// Helper functions to check permissions
export const canPerformAction = (userRole, action) => {
  return PERMISSIONS[action]?.includes(userRole) || false;
};

export const canViewTicket = (userRole, ticket, userId, userDepartment) => {
  if (canPerformAction(userRole, 'VIEW_ALL_TICKETS')) return true;
  if (ticket.submittedBy === userId) return true;
  if (canPerformAction(userRole, 'VIEW_DEPARTMENT_TICKETS') && 
      ticket.department === userDepartment) return true;
  return false;
};

// Get available status transitions based on role and current status
export const getAvailableStatusTransitions = (userRole, currentStatus) => {
  const transitions = {
    [ROLES.USER]: {
      [TICKET_STATUS.COMPLETED]: [TICKET_STATUS.VERIFIED, TICKET_STATUS.VERIFICATION],
      [TICKET_STATUS.DRAFT]: [TICKET_STATUS.SUBMITTED]
    },
    [ROLES.MANAGER]: {
      [TICKET_STATUS.SUBMITTED]: [
        TICKET_STATUS.MANAGER_APPROVED,
        TICKET_STATUS.MANAGER_REJECTED
      ]
    },
    [ROLES.MAINTENANCE_MANAGER]: {
      [TICKET_STATUS.MANAGER_APPROVED]: [
        TICKET_STATUS.ASSIGNED,
        TICKET_STATUS.CANCELLED
      ],
      [TICKET_STATUS.IN_PROGRESS]: [TICKET_STATUS.CANCELLED]
    },
    [ROLES.MAINTENANCE_STAFF]: {
      [TICKET_STATUS.ASSIGNED]: [
        TICKET_STATUS.IN_PROGRESS,
        TICKET_STATUS.WAITING_PARTS
      ],
      [TICKET_STATUS.IN_PROGRESS]: [
        TICKET_STATUS.COMPLETED,
        TICKET_STATUS.WAITING_PARTS
      ],
      [TICKET_STATUS.WAITING_PARTS]: [TICKET_STATUS.IN_PROGRESS]
    },
    [ROLES.FINANCE]: {
      [TICKET_STATUS.VERIFIED]: [
        TICKET_STATUS.FINANCE_REVIEW,
        TICKET_STATUS.CLOSED
      ]
    }
  };

  return transitions[userRole]?.[currentStatus] || [];
}; 